import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useGetParcelsQuery } from "../api/parcelApiSlice";
import * as Roles from "../models/security/Roles";
import { userHasRole } from "../providers/SecurityProvider";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import * as ParcelStore from "../store/ParcelStore";

const POLLING_INTERVAL_MS = 30 * 1000; // 30 seconds

export function useApprovedAuctionBidder() {
    const [isDismissed, setIsDismissed] = useState(false);

    const dispatch = useAppDispatch();
    const user = useAppSelector((state) => state.userStoreState.user);
    const params = useParams<{ url: string }>();

    const saleUrl = params.url ?? "";

    const parcelsQuery = useGetParcelsQuery(saleUrl, {
        pollingInterval: POLLING_INTERVAL_MS,
        skipPollingIfUnfocused: true,
        refetchOnFocus: true
    });

    if (!saleUrl) {
        throw new Error("`url` parameter is required");
    }

    const isApproved = parcelsQuery.data?.isApprovedAuctionBidder;
    const isLoading = parcelsQuery.isLoading;

    useEffect(() => {
        if (isApproved === undefined) {
            return;
        }

        dispatch(
            ParcelStore.actionCreators.updateAuctionBidderApprovalStatus(
                isApproved
            )
        );
    }, [dispatch, isApproved]);

    const isAdmin = userHasRole(Roles.Administrator)(user);
    const isUserLoggedIn = !!user?.id;

    const isDialogOpen =
        !isDismissed && !isAdmin && !isLoading && !isApproved && isUserLoggedIn;

    const closeDialog = () => setIsDismissed(true);

    return { isApproved, isLoading, isDialogOpen, closeDialog };
}
